/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Upgrade_DescInputs */

const en_interview_upgrade_desc = /** @type {(inputs: Interview_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare for interviews with AI-powered question generation, practice with real-time feedback, company research briefs, and curated question banks by role and seniority.`)
};

const de_interview_upgrade_desc = /** @type {(inputs: Interview_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereite dich auf Vorstellungsgespräche vor mit KI-gestützter Fragengenerierung, Übungen mit Echtzeit-Feedback, Unternehmens-Recherche und kuratierten Fragenbanken nach Rolle und Erfahrungsstufe.`)
};

const fr_interview_upgrade_desc = /** @type {(inputs: Interview_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prépare-toi aux entretiens avec la génération de questions par IA, des exercices avec retour en temps réel, des fiches entreprise et des banques de questions par poste et niveau d'expérience.`)
};

const es_interview_upgrade_desc = /** @type {(inputs: Interview_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepárese para entrevistas con generación de preguntas por IA, práctica con retroalimentación en tiempo real, informes de empresas y bancos de preguntas por puesto y nivel de experiencia.`)
};

const it_interview_upgrade_desc = /** @type {(inputs: Interview_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparati per i colloqui con generazione di domande assistita dall'AI, esercitazione con feedback in tempo reale, schede di ricerca aziendale e banche di domande per ruolo e seniority.`)
};

const nl_interview_upgrade_desc = /** @type {(inputs: Interview_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereid je voor op sollicitatiegesprekken met AI-gestuurde vragen, oefen met realtime feedback, bedrijfsonderzoeksnotities en vragenbanken per rol en senioriteit.`)
};

const pl_interview_upgrade_desc = /** @type {(inputs: Interview_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotuj się do rozmów kwalifikacyjnych dzięki generowaniu pytań przez AI, ćwiczeniom z feedbackiem w czasie rzeczywistym, notatkom o firmach i bankom pytań według roli i doświadczenia.`)
};

const fi_interview_upgrade_desc = /** @type {(inputs: Interview_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmistaudu haastatteluihin tekoälypohjaisella kysymysten luonnilla, harjoittele reaaliaikaisella palautteella, yritystutkimustiivistelmillä ja räätälöidyillä kysymyspankeilla.`)
};

const da_interview_upgrade_desc = /** @type {(inputs: Interview_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbered dig til samtaler med AI-drevne spørgsmål, øvelse med realtidsfeedback, firmaoversigter og skræddersyede spørgsmålsbanker efter rolle og senioritet.`)
};

const sv_interview_upgrade_desc = /** @type {(inputs: Interview_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förbered dig för intervjuer med AI-genererade frågor, öva med realtidsfeedback, företagsöversikter och skräddarsydda frågebanker per roll och senioritet.`)
};

/**
* | output |
* | --- |
* | "Prepare for interviews with AI-powered question generation, practice with real-time feedback, company research briefs, and curated question banks by role and..." |
*
* @param {Interview_Upgrade_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_upgrade_desc = /** @type {((inputs?: Interview_Upgrade_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Upgrade_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_upgrade_desc(inputs)
	if (locale === "fr") return fr_interview_upgrade_desc(inputs)
	if (locale === "es") return es_interview_upgrade_desc(inputs)
	if (locale === "it") return it_interview_upgrade_desc(inputs)
	if (locale === "nl") return nl_interview_upgrade_desc(inputs)
	if (locale === "pl") return pl_interview_upgrade_desc(inputs)
	if (locale === "fi") return fi_interview_upgrade_desc(inputs)
	if (locale === "da") return da_interview_upgrade_desc(inputs)
	if (locale === "sv") return sv_interview_upgrade_desc(inputs)
	return en_interview_upgrade_desc(inputs)
});